import {cn} from 'platform/shared-tw';

import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface RearLeftSideshaftProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function RearLeftSideshaft(props: RearLeftSideshaftProps) {
  return (
    <svg
      width="38"
      height="75"
      viewBox="0 0 38 75"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute [pointer-events:none] cursor-pointer group"
      style={{right: 283, bottom: 147}}
      onClick={props.onClick}
    >
      <path
        d="M35 6C35 6 37 5.99998 37 4V1H1V4C1.00002 5.99998 3 6 3 6H7V10H5C5 10 3.00001 10 3 12V14C3.00001 16 5 16 5 16H11C11 16 9 16 9 18C9.00001 20 11 20 11 20H13C13 20 11 20 11 22C11 24 13 24 13 24H15C15 24 13 24 13 26C13 28 15 28 15 28V74H23V28C23 28 25 28 25 26C25 24 23 24 23 24H25C25 24 27 24 27 22C27 20 25 20 25 20H27C27 20 29 20 29 18C29 16 27 16 27 16H33C33 16 35 16 35 14V12C35 10 33 10 33 10H31V6H35Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M23 28V74H15V28H23Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M23 28H19H15C15 28 13 28 13 26C13 24 15 24 15 24H19H23C23 24 25 24 25 26C25 28 23 28 23 28Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M25 24H19H13C13 24 11 24 11 22C11 20 13 20 13 20H19H25C25 20 27 20 27 22C27 24 25 24 25 24Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M27 20H19H11C11 20 9 20 9 18C9 16 11 16 11 16H19H27C27 16 29 16 29 18C29 20 27 20 27 20Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M33 10H19H5C5 10 3 10 3 12V13V14C3 16 5 16 5 16H19H33C33 16 35 16 35 14V13V12C35 10 33 10 33 10Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M35 5.99998H19H3C3 5.99998 1 5.99998 1 3.99997V1H37V3.99997C37 5.99998 35 5.99998 35 5.99998Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <rect
        x="7"
        y="6"
        width="24"
        height="4"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
    </svg>
  );
}
